import React, { useState } from 'react';
import {
  BiEdit,
  BiTrash,
  BiCopy,
  BiCode,
  BiListUl,
  BiInfoCircle,
  BiCheckCircle,
  BiXCircle,
} from 'react-icons/bi';
import { AiOutlineFunction, AiOutlineTag } from 'react-icons/ai';
import { MdSettings, MdDescription } from 'react-icons/md';

import Bouton from '../../UI/Bouton/Bouton';

import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import S from './ProfilTasks.module.scss';

const ProfilTasks = ({ infoTask, reqModifier, reqSupprimer }) => {
  const [activeTab, setActiveTab] = useState('general');
  const [showJsonExport, setShowJsonExport] = useState(false);

  const handleEdit = () => {
    if (reqModifier) {
      reqModifier(infoTask);
    }
  };

  const handleDelete = () => {
    if (
      window.confirm(
        `Êtes-vous sûr de vouloir supprimer la tache "${infoTask.nom}" ?`
      )
    ) {
      if (reqSupprimer) {
        reqSupprimer(infoTask.id);
      }
    }
  };

  const handleDuplicate = () => {
    const duplicateTask = {
      ...infoTask,
      id: `${infoTask.id}_copy_${Date.now()}`,
      nom: `${infoTask.nom} (Copie)`,
    };

    if (reqModifier) {
      reqModifier(duplicateTask);
    }
  };

  const getTypeIcon = (type) => {
    const icons = {
      sensors_list: '📊',
      date_range: '📅',
      frequency: '⏱️',
      number: '🔢',
      text: '📝',
      boolean: '☑️',
      select: '📋',
      multi_select: '📚',
      file: '📁',
      json: '🔧',
    };
    return icons[type] || '⚙️';
  };

  const getTypeBadge = (type) => {
    const colors = {
      system: '#007bff',
      custom: '#28a745',
      user: '#fd7e14',
    };
    return colors[type] || '#6c757d';
  };

  if (!infoTask || !infoTask.id) {
    return (
      <div className={S.profilContainer}>
        <div className={S.emptyState}>
          <BiInfoCircle size={48} className={S.emptyIcon} />
          <h3>Aucune t�che sélectionnée</h3>
          <p>Sélectionnez une t�che dans le tableau pour voir ses détails</p>
        </div>
      </div>
    );
  }

  return (
    <div className={S.profilContainer}>
      {/* Header avec icône de t�che */}
      <div className={S.header}>
        <div className={S.headerInfo}>
          <div className={S.functionIcon}>
            <AiOutlineFunction size={24} />
          </div>
          <div className={S.functionTitle}>
            <h2 className={S.functionName}>{infoTask.nom}</h2>
            <div className={S.functionMeta}>
              <span
                className={S.typeBadge}
                style={{
                  backgroundColor: getTypeBadge(infoTask.type),
                }}
              >
                {infoTask.type || 'custom'}
              </span>
              <span className={S.functionId}>ID: {infoTask.id}</span>
            </div>
          </div>
        </div>

        <div className={S.headerActions}>
          <Bouton
            type={type_btn.secondary}
            cliquer={handleDuplicate}
            taille="small"
            rond={true}
            ajoutClass={S.actionBtn}
          >
            <BiCopy size={16} />
          </Bouton>
          <Bouton
            type={type_btn.primary}
            cliquer={handleEdit}
            taille="small"
            rond={true}
            ajoutClass={S.actionBtn}
          >
            <BiEdit size={16} />
          </Bouton>
          <Bouton
            type={type_btn.danger}
            cliquer={handleDelete}
            taille="small"
            rond={true}
            ajoutClass={S.actionBtn}
          >
            <BiTrash size={16} />
          </Bouton>
        </div>
      </div>

      {/* Navigation Tabs */}
      <div className={S.tabsContainer}>
        <div className={S.tabs}>
          <button
            className={`${S.tab} ${activeTab === 'general' ? S.tabActive : ''}`}
            onClick={() => setActiveTab('general')}
          >
            <BiInfoCircle size={16} />
            Général
          </button>
          <button
            className={`${S.tab} ${
              activeTab === 'arguments' ? S.tabActive : ''
            }`}
            onClick={() => setActiveTab('arguments')}
          >
            <BiListUl size={16} />
            Arguments ({infoTask.arguments?.length || 0})
          </button>
          <button
            className={`${S.tab} ${activeTab === 'export' ? S.tabActive : ''}`}
            onClick={() => setActiveTab('export')}
          >
            <BiCode size={16} />
            Export
          </button>
        </div>
      </div>

      {/* Contenu des tabs */}
      <div className={S.tabContent}>
        {activeTab === 'general' && (
          <div className={S.generalTab}>
            {/* Description */}
            {infoTask.description && (
              <div className={S.card}>
                <div className={S.cardHeader}>
                  <MdDescription size={18} />
                  <h3>Description</h3>
                </div>
                <div className={S.cardBody}>
                  <p className={S.description}>{infoTask.description}</p>
                </div>
              </div>
            )}

            {/* Statistiques */}
            <div className={S.card}>
              <div className={S.cardHeader}>
                <AiOutlineTag size={18} />
                <h3>Statistiques</h3>
              </div>
              <div className={S.cardBody}>
                <div className={S.statsGrid}>
                  <div className={S.statItem}>
                    <div className={S.statValue}>
                      {infoTask.arguments?.length || 0}
                    </div>
                    <div className={S.statLabel}>Arguments</div>
                  </div>
                  <div className={S.statItem}>
                    <div className={S.statValue}>
                      {infoTask.arguments?.filter((arg) => arg.obligatoire)
                        .length || 0}
                    </div>
                    <div className={S.statLabel}>Obligatoires</div>
                  </div>
                  <div className={S.statItem}>
                    <div className={S.statValue}>
                      {infoTask.arguments?.filter((arg) => !arg.obligatoire)
                        .length || 0}
                    </div>
                    <div className={S.statLabel}>Optionnels</div>
                  </div>
                  <div className={S.statItem}>
                    <div className={S.statValue}>
                      {
                        new Set(
                          infoTask.arguments?.map((arg) => arg.type) || []
                        ).size
                      }
                    </div>
                    <div className={S.statLabel}>Types différents</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Types d'arguments utilisés */}
            <div className={S.card}>
              <div className={S.cardHeader}>
                <MdSettings size={18} />
                <h3>Types d'arguments utilisés</h3>
              </div>
              <div className={S.cardBody}>
                <div className={S.typesList}>
                  {[
                    ...new Set(
                      infoTask.arguments?.map((arg) => arg.type) || []
                    ),
                  ].map((type) => (
                    <div key={type} className={S.typeItem}>
                      <span className={S.typeIcon}>{getTypeIcon(type)}</span>
                      <span className={S.typeName}>{type}</span>
                      <span className={S.typeCount}>
                        {
                          infoTask.arguments?.filter((arg) => arg.type === type)
                            .length
                        }
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'arguments' && (
          <div className={S.argumentsTab}>
            {!infoTask.arguments || infoTask.arguments.length === 0 ? (
              <div className={S.emptyArguments}>
                <BiListUl size={48} className={S.emptyIcon} />
                <h3>Aucun argument</h3>
                <p>Cette t�che ne possède aucun argument défini</p>
              </div>
            ) : (
              <div className={S.argumentsList}>
                {infoTask.arguments
                  .sort((a, b) => (a.position || 0) - (b.position || 0))
                  .map((argument, index) => (
                    <div key={argument.id || index} className={S.argumentCard}>
                      <div className={S.argumentHeader}>
                        <div className={S.argumentInfo}>
                          <div className={S.argumentPosition}>
                            #{(argument.position || 0) + 1}
                          </div>
                          <div className={S.argumentNameSection}>
                            <h4 className={S.argumentName}>{argument.nom}</h4>
                            <div className={S.argumentLabels}>
                              <span className={S.argumentType}>
                                {getTypeIcon(argument.type)}
                                {argument.type}
                              </span>
                              {argument.obligatoire ? (
                                <span
                                  className={`${S.requiredBadge} ${S.required}`}
                                >
                                  <BiCheckCircle size={14} />
                                  Obligatoire
                                </span>
                              ) : (
                                <span
                                  className={`${S.requiredBadge} ${S.optional}`}
                                >
                                  <BiXCircle size={14} />
                                  Optionnel
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {argument.description && (
                        <div className={S.argumentDescription}>
                          <strong>Description:</strong>
                          {argument.description}
                        </div>
                      )}

                      {argument.valeurParDefaut !== undefined &&
                        argument.valeurParDefaut !== '' && (
                          <div className={S.argumentDefault}>
                            <strong>Valeur par défaut:</strong>
                            <code className={S.defaultValue}>
                              {typeof argument.valeurParDefaut === 'object'
                                ? JSON.stringify(argument.valeurParDefaut)
                                : String(argument.valeurParDefaut)}
                            </code>
                          </div>
                        )}

                      {argument.options &&
                        Object.keys(argument.options).length > 0 && (
                          <div className={S.argumentOptions}>
                            <strong>Options de configuration:</strong>
                            <div className={S.optionsGrid}>
                              {Object.entries(argument.options).map(
                                ([key, value]) => (
                                  <div key={key} className={S.optionItem}>
                                    <span className={S.optionKey}>{key}:</span>
                                    <span className={S.optionValue}>
                                      {Array.isArray(value)
                                        ? `[${value.length} éléments]`
                                        : typeof value === 'object' &&
                                          value !== null
                                        ? `{${
                                            Object.keys(value).length
                                          } propriétés}`
                                        : String(value)}
                                    </span>
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  ))}
              </div>
            )}
          </div>
        )}

        {activeTab === 'export' && (
          <div className={S.exportTab}>
            <div className={S.card}>
              <div className={S.cardHeader}>
                <BiCode size={18} />
                <h3>Export JSON</h3>
                <button
                  className={S.toggleBtn}
                  onClick={() => setShowJsonExport(!showJsonExport)}
                >
                  {showJsonExport ? 'Masquer' : 'Afficher'}
                </button>
              </div>
              {showJsonExport && (
                <div className={S.cardBody}>
                  <pre className={S.jsonExport}>
                    {JSON.stringify(infoTask, null, 2)}
                  </pre>
                </div>
              )}
            </div>

            <div className={S.card}>
              <div className={S.cardHeader}>
                <BiInfoCircle size={18} />
                <h3>Informations d'export</h3>
              </div>
              <div className={S.cardBody}>
                <div className={S.exportInfo}>
                  <div className={S.exportItem}>
                    <strong>Taille JSON:</strong>{' '}
                    {JSON.stringify(infoTask).length}
                    caractères
                  </div>
                  <div className={S.exportItem}>
                    <strong>Dernière modification:</strong>{' '}
                    {new Date().toLocaleString()}
                  </div>
                  <div className={S.exportItem}>
                    <strong>Format:</strong>
                    JSON (JavaScript Object Notation)
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfilTasks;




